import { Gold } from "../../Gold";

interface GoldFormatterProps {
  value: number | null | undefined;
}

export const GoldFormatter = ({ value }: GoldFormatterProps) => (
  <Gold fullWidth value={value} />
);
